import store from '@/store';

const VALID_COUNTRIES = ['SWEDEN', 'NORWAY', 'GERMANY'];

export function getUserCountry(): string {
  const userLocation: string = store.state.userLocation || 'SWEDEN';
  return VALID_COUNTRIES.includes(userLocation) ? userLocation : 'SWEDEN';
}
